export default class NfseEntity {
  serieDocumento = "";
  clienteId = null;
  clienteNome = "";
  clienteCnpjCpf = "";
  clienteEnderecoRua = "";
  clienteEnderecoNumero = "";
  clienteEnderecoBairro = "";
  clienteEnderecoComplemento = "";
  clienteEnderecoCidade = "";
  clienteEnderecoUf = "";
  clienteEnderecoCep = "";
  descricaoServico = "";
  dataPrestacao = null;
  servicos = [];

  constructor(nfse) {
    this.clienteId = nfse?.clienteId || null;
    this.clienteNome = nfse?.clienteNome || null;
    this.clienteCnpjCpf = nfse?.clienteCnpjCpf || null;
    this.clienteEnderecoRua = nfse?.clienteEnderecoRua || null;
    this.clienteEnderecoNumero = nfse?.clienteEnderecoNumero || null;
    this.clienteEnderecoBairro = nfse?.clienteEnderecoBairro || null;
    this.clienteEnderecoComplemento = nfse?.clienteEnderecoComplemento || null;
    this.clienteEnderecoCidade = nfse?.clienteEnderecoCidade || null;
    this.clienteEnderecoUf = nfse?.clienteEnderecoUf || null;
    this.clienteEnderecoCep = nfse?.clienteEnderecoCep || null;
    this.descricaoServico = nfse?.descricaoServico || null;
    this.dataPrestacao = nfse?.dataPrestacao || null;
  }

  setSerieDocumento(nfse) {
    this.serieDocumento = nfse.serieDocumento || "";
  }

  setServicos(servicos) {
    this.servicos = servicos;
  }
}
